const dfPhotosVideos = {
  introHead: 'Organizza i tuoi file',
  introDescription:
    'Ti aiutiamo a organizzare e archiviare in modo sicuro foto e video importanti.',
};

export default dfPhotosVideos;
